import React from "react";
import { Box, CircularProgress } from "@mui/material";

const ProgressLoad = () => (
  <Box sx={{ display: "flex", justifyContent: "center", m: 3 }}>
    <CircularProgress />
  </Box>
);
export default ProgressLoad;
